


function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}

function insertAfter(newNode, existingNode) {
  existingNode?.parentNode.insertBefore(newNode, existingNode?.nextSibling);
}

window.smoothScroll = function (target) {
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

const wait = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
  }
};
const setActive = (el) => {
  [...el.parentElement.children].forEach((sib) =>
    sib.classList.remove("active")
  );
  el.classList.add("active");
};

let getSiblings = function (e) {
  let siblings = [];
  if (!e.parentNode) {
    return siblings;
  }
  let sibling = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};
let previousSiblings = (elem) => {
  let siblings = [];
  while (elem = elem.previousElementSibling) {
    siblings.push(elem);
  }
  return siblings;
};
let nextSiblings = (elem) => {
  let siblings = [];
  while (elem = elem.nextElementSibling) {
    siblings.push(elem);
  }
  return siblings;
};

const faqBLocks = document.querySelectorAll(".faq-block");
const faqBanner = document.querySelector('.faq-banner-section');

var getInView = wait(function () {
  faqBLocks.forEach(block => {
    const _isInViewport = isInViewport(block);
    if (_isInViewport) {

      const block_id = block.getAttribute('id');
      const rel_menu = document.querySelector(`[data-toggle="${block_id}"]`);
      setActive(rel_menu.closest('li'));
    }

  });
}, 100);

document.addEventListener('scroll', getInView);
document.addEventListener("DOMContentLoaded", getInView);

const driveMenuItems = document.querySelectorAll(".drive-menu .list-item a");
driveMenuItems.forEach(listItem => {
  listItem.addEventListener("click", function (event) {
    event.preventDefault();
    smoothScroll(document.getElementById(listItem.dataset.toggle));
    setActive(listItem.closest('li'));
  })
});

var swiper = new Swiper('.swiper', {
  loop: false,
  centeredSlides: false,
  preventClicks: true,
  preventClicksPropagation: true,
  autoplay: {
    delay: 5500,
  },
  speed: 1500,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});

var productsSwiper = new Swiper('.products-swiper', {
  // Optional parameters
  loop: false,
  spaceBetween: 20,
  speed: 1000,
  preventClicks: true,
  preventClicksPropagation: true,
  breakpoints: {
    640: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    slidesPerView: 1.415,
    spaceBetween: 25,
  },
  // If we need pagination
  navigation: {
    nextEl: '.featured-products-section .swiper-button-next',
    prevEl: '.featured-products-section .swiper-button-prev',
  }
});

var productsContentSwiper = new Swiper('.products-swiper-mobile-content', {
  // Optional parameters
  loop: false,
  spaceBetween: 20,
  speed: 1000,
  effect: 'fade',
  allowTouchMove: false,
  breakpoints: {
    640: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    slidesPerView: 1.415,
    spaceBetween: 25,
  }
});
var productsImageSwiper = new Swiper('.products-swiper-mobile-image', {
  // Optional parameters
  loop: false,
  spaceBetween: 20,
  speed: 1000,
  breakpoints: {
    640: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    slidesPerView: 1.415,
    spaceBetween: 25,
  }

});
if (productsContentSwiper.length > 0 || productsImageSwiper.length > 0) {
  productsContentSwiper.forEach((element, index) => {
    element.controller.control = productsImageSwiper[index];
    productsImageSwiper[index].controller.control = element;
  });
} else {
  productsContentSwiper.controller.control = productsImageSwiper;
  productsImageSwiper.controller.control = productsContentSwiper;
}


const slides = document.querySelectorAll('.category-slider .swiper-slide');
var virtualSlides = [];
slides.forEach(element => {
  virtualSlides.push(element.outerHTML);
});
const slider_wrapper = document.querySelector(".category-slider .swiper-wrapper");
virtualSlides.forEach(element => {
  slider_wrapper.innerHTML = slider_wrapper.innerHTML + element;
});

var categorySwiper = new Swiper('.category-slider', {
  // Optional parameters
  enabled: true,
  loop: true,
  centeredSlides: true,
  navigation: {
    prevEl: '.category-slider .swiper-button-prev',
    nextEl: '.category-slider .swiper-button-next'
  },
  // lazy: {
  //   loadPrevNext: true,
  //   loadPrevNextAmount: 3,
  //   loadOnTransitionStart: true
  // },
  // watchSlidesVisibility: true,
  breakpoints: {
    375: {
      slidesPerView: 2.25,
      spaceBetween: 16,
    },
    420: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 32,
    },
  },
});



const aboutslides = document.querySelectorAll('.about-slider .swiper-slide');
var virtualAboutSlides = [];
aboutslides.forEach(element => {
  virtualAboutSlides.push(element.outerHTML);
});
const aboutslider_wrapper = document.querySelector(".about-slider .swiper-wrapper");
virtualAboutSlides.forEach(element => {
  aboutslider_wrapper.innerHTML = aboutslider_wrapper.innerHTML + element;
});

const slider = new Swiper('.about-slider', {
  loop: true,
  speed: 1100,
  observer: true,
  centeredSlides: true,
  loopedSlides: 3,
  breakpoints: {
    640: {
      slidesPerView: 1.5,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView: 1.8,
      spaceBetween: 30
    },
  },

  preventClicks: true,
  preventClicksPropagation: true,
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next'
  },
  on: {
    slideChangeTransitionStart: function () {
      setBeforePrevAfterNext(this)
      var sliderNavs = document.querySelector('.about-slider-wrapper .slider-navs');
      var activeIndex = document.querySelector('.swiper-slide-active').getAttribute('data-swiper-slide-index');
      sliderNavs.setAttribute('data-index', activeIndex)

    }
  }
})



function setBeforePrevAfterNext($swiper) {
  let prev = $swiper.el.querySelector('.swiper-slide-prev')
  let next = $swiper.el.querySelector('.swiper-slide-next')
  let before_prev = prev.previousElementSibling
  let after_next = next.nextElementSibling

  $swiper.el.querySelectorAll('.swiper-slide-before-prev').forEach(element => {
    element.classList.remove('swiper-slide-before-prev')
  })
  $swiper.el.querySelectorAll('.swiper-slide-after-next').forEach(element => {
    element.classList.remove('swiper-slide-after-next')
  })

  before_prev.classList.add('swiper-slide-before-prev')
  after_next.classList.add('swiper-slide-after-next')

}

const quiz_section = document.querySelectorAll('.quiz-section');
const window_width = window.innerWidth;
quiz_section.forEach(section => {
  const blocks = section.querySelectorAll('.block');

  blocks.forEach(block => {
    const title_wrapper = block.querySelector(".title-nav-wrapper");
    const title = block.querySelector(".title-nav-wrapper .title");
    const cards_wrapper = block.querySelector(".cards-wrapper");

    const card_wrapper = block.querySelectorAll(".card-wrapper");

    const radios = block.querySelectorAll('input[type="radio"]');
    const next_button = block.querySelector('.block-check');
    const prev_button = block.querySelector('.prev-button');
    prev_button?.addEventListener("click", function () {
      block.previousElementSibling.classList.remove("d-none");
      block.classList.add('d-none');
    });
    card_wrapper.forEach(card => {
      card.addEventListener("click", (event) => {

        const radio = card.querySelector('input[type="radio"]');
        radio.checked = true;
        let changeEvent = new Event('change');
        radio.dispatchEvent(changeEvent);
        next_button?.classList.remove("disabled");
        next_button?.click();
        if (next_button?.classList.contains('submit-form-trigger')) {
          next_button?.addEventListener("click", function (event) {
            event.preventDefault();
            const checked_options = section.querySelectorAll("input[type='radio']:checked");
            var tags = '';
            var count = 5;
            var order = [2, 0, 1, 3];
            var orderDict = order.reduce((acc, item, index) => {
              acc[item] = index;
              return acc;
            }, {});

            const sortedOptions = Array.from(checked_options).sort((a, b) => {
              return orderDict[Array.from(checked_options).indexOf(a)] - orderDict[Array.from(checked_options).indexOf(b)]
            }
            );
            sortedOptions.forEach((option, index) => {
              // const value = 'filter.p.tag='+option.value;

              var value;
              if (index == 0) {
                value = 'gf_475082=' + option.value;
              } else {
                count = count + 1;
                value = `gf_47551${count}=` + option.value;
              }
              if (tags == '') {
                tags = value;
              } else {
                tags = tags + "&" + value;
              }
            })
            const url = Shopify.routes.root + "collections/all?" + tags;
            // location.replace(url);
            location.href = url
          })
        } else {
          next_button?.addEventListener("click", function (e) {
            e.preventDefault();
            const prevSiblings = previousSiblings(block);
            const nextBlock = block.nextElementSibling;
            nextBlock.classList.remove('d-none')
            block.classList.add('selected', 'd-none');
            if (prevSiblings.length == 1) {
              const type = prevSiblings[0].dataset.value;
              const parent = block.dataset.value;
              const cardsTofilter = nextBlock.querySelectorAll(`.card-wrapper`);
              for (let index = 0; index < cardsTofilter.length; index++) {
                const card = cardsTofilter[index];
                card.classList.remove('d-none');
                if (blocks[1].dataset.value == "Adults") {
                  const label = card.querySelector('label').innerText;
                  if (label == "Boy") {
                    card.querySelector('label').innerText = "Male"
                  }
                  if (label == "Girl") {
                    card.querySelector('label').innerText = "Female"
                  }
                } else {
                  const label = card.querySelector('label').innerText;
                  if (label == "Male") {
                    card.querySelector('label').innerText = "Boy"
                  }
                  if (label == "Female") {
                    card.querySelector('label').innerText = "Girl"
                  }
                }
                if (card.dataset.type != type && card.dataset.parent != parent) {
                  card.classList.add('d-none')
                }
              }
            }

          })
        }
      })
    });
    radios.forEach(radio => {
      radio.addEventListener("change", function (event) {
        section.querySelectorAll(".card-wrapper").forEach(card => {
          if (radio.value == "Adults") {
            const label = (card.querySelector('label').innerText).trim();
            if (label == window.quizStrings.kidMale) {
              card.querySelector('label').innerText = window.quizStrings.adultMale
            }
            if (label == window.quizStrings.kidFemale) {
              card.querySelector('label').innerText = window.quizStrings.adultFemale
            }
          } if (radio.value == "Kids") {
            const label = (card.querySelector('label').innerText).trim();
            if (label == window.quizStrings.adultMale) {
              card.querySelector('label').innerText = window.quizStrings.kidMale;
            }
            if (label == window.quizStrings.adultFemale) {
              card.querySelector('label').innerText = window.quizStrings.kidFemale
            }
          }

        });
        next_button?.classList.remove('disabled');
        block.dataset.value = radio.value;
        if (next_button?.classList.contains('submit-form-trigger')) {
          next_button?.addEventListener("click", function (event) {
            event.preventDefault();
            const checked_options = section.querySelectorAll("input[type='radio']:checked");
            var tags = '';
            var count = 5;
            var order = [2, 0, 1, 3];
            var orderDict = order.reduce((acc, item, index) => {
              acc[item] = index;
              return acc;
            }, {});

            const sortedOptions = Array.from(checked_options).sort((a, b) => {
              return orderDict[Array.from(checked_options).indexOf(a)] - orderDict[Array.from(checked_options).indexOf(b)]
            }
            );
            sortedOptions.forEach((option, index) => {
              // const value = 'filter.p.tag='+option.value;
              var giftRecipient;
              if (Array.from(checked_options)[0].value == 'gift') {
                if (Array.from(sortedOptions)[2].value == 'Child') {
                  giftRecipient = '445215211800'
                }
                if (Array.from(sortedOptions)[2].value == 'Adults') {
                  giftRecipient = '464491643160'
                }
                tags = `gf_475082=${Array.from(sortedOptions)[0].value}&gf_475518=${Array.from(sortedOptions)[3].value}&gf_475521=${giftRecipient}`
                return;
              }
              else {
                var value;
                if (index == 0) {
                  value = 'gf_475082=' + option.value;
                } else {
                  count = count + 1;
                  value = `gf_47551${count}=` + option.value;
                }
                if (tags == '') {
                  tags = value;
                } else {
                  tags = tags + "&" + value;
                }
              }
            })
            const url = Shopify.routes.root + "collections/all?" + tags;
            location.href = url;
          })
        } else {
          next_button?.addEventListener("click", function (e) {
            e.preventDefault();
            const prevSiblings = previousSiblings(block);
            const nextBlock = block.nextElementSibling;
            nextBlock.classList.remove('d-none')
            block.classList.add('selected', 'd-none');
            if (prevSiblings.length == 1) {
              const type = prevSiblings[0].dataset.value.toLowerCase();
              const parent = block.dataset.value.toLowerCase();
              const cardsTofilter = nextBlock.querySelectorAll(`.card-wrapper`);
              for (let index = 0; index < cardsTofilter.length; index++) {
                const card = cardsTofilter[index];
                const dataParent = card.getAttribute('data-parent'), dataType = card.getAttribute('data-type').toLowerCase();
                card.classList.add('d-none');
                if (dataType == type && dataParent == parent) {
                  card.classList.remove('d-none')
                }
              }
            }

          })
        }

      })
    })

    if (window.innerWidth < 1024) {
      insertAfter(cards_wrapper, title);
    } else {
      insertAfter(cards_wrapper, title_wrapper);
    }
    window.addEventListener("resize", (event) => {
      if (window.innerWidth < 1024) {
        insertAfter(cards_wrapper, title);
      } else {
        insertAfter(cards_wrapper, title_wrapper);
      }
    });

  })
  // quiz_cards.forEach(card => {
  //   const group = card.dataset.group;
  //   const 

  // })

})
const menu_toggles = document.querySelectorAll('.mega-menu summary.link');
const mega_content = document.querySelectorAll(".mega-menu .mega-menu__content");
// const mobile_level_2_close = document.querySelectorAll(".menu-level-2 .icon-minus");
const search_toggler = document.querySelector(".header-search_mobile");
const search_sidebar = document.querySelector(".search-drawer");
const search_close = document.querySelector(".button.cancel-button");
const search_toggler_desk = document.querySelector(".header__icons .header__icon--search");
const desk_search = document.querySelector('.desk-search-drawer')
const search_close_desk = document.querySelector('.desk-search-drawer .modal__close-button');
menu_toggles.forEach(element => {
  element.addEventListener('mouseenter', function (event) {
    hideAllmenus();
    if (event.currentTarget.closest('details') != null) {
      if (!event.currentTarget.closest('details').hasAttribute('open')) {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        event.currentTarget.closest('details').setAttribute('open', '');
      }
    } else {
      hideAllmenus();
    }
  })
});
mega_content.forEach(element => {
  element.addEventListener('mouseleave', function (event) {
    hideAllmenus();
    if (event.currentTarget.closest('details').hasAttribute('open')) {
      event.currentTarget.previousElementSibling.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      event.currentTarget.closest('details').removeAttribute('open');
    }
  })
});
// mobile_level_2_close.forEach(element => {
// element.addEventListener('click', (event) => {
//   event.preventDefault();
//   event.stopImmediatePropagation();
//   const detailsElement = event.currentTarget.closest('details');
//   closeSubmenu(detailsElement);
// })
// })
search_toggler.addEventListener("click", (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  search_sidebar.classList.toggle('is-open');
  document.querySelector('body').classList.add('drawer-open');
})
search_close.addEventListener("click", (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  search_sidebar.classList.remove('is-open');
  document.querySelector('body').classList.remove('drawer-open');
})
search_toggler_desk.addEventListener("click", (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  desk_search.classList.toggle('is-shown');
  document.querySelector('body').classList.toggle('drawer-open');
});
search_close_desk.addEventListener("click", (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  desk_search.classList.remove('is-shown');
  document.querySelector('body').classList.remove('drawer-open', 'overflow-hidden');
});

function hideAllmenus() {
  menu_toggles.forEach(element => {
    element.setAttribute('aria-expanded', 'false');
    element.closest('details').removeAttribute('open');
  })
}
function closeSubmenu(detailsElement) {
  const parentMenuElement = detailsElement?.closest('.submenu-open');
  parentMenuElement && parentMenuElement.classList.remove('submenu-open');
  detailsElement.classList.remove('menu-opening');
  detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
  removeTrapFocus(detailsElement.querySelector('summary'));
  closeAnimation(detailsElement);
}
function closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul.disclosure__list'),
    };

    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.querySelectorAll('#CountryList li a').forEach(
      item => item.addEventListener('click', (event) => { this.citySelector(event) }));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    this.changeCity();
    this.changeForm();
    this.setCurrentCityInElement();
  }

  setCurrentCityInElement() {
    const location_names = this.elements.button.querySelectorAll('span.location_name');
    location_names.forEach(el => el.classList.add('hidden'));

    const pickedCity = (localStorage.getItem('selectedCity') || window.defaultCity).trim();

    if (pickedCity == 'RIYADH') {
      this.elements.button.querySelector('span.riyadh')?.classList.remove('hidden');
    } else if (pickedCity == 'JEDDAH') {
      this.elements.button.querySelector('span.jeddah')?.classList.remove('hidden');
    } else if (pickedCity == 'DOHA') {
      this.elements.button.querySelector('span.doha')?.classList.remove('hidden');
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
  citySelector(event) {
    this.elements.panel.toggleAttribute('hidden');

    const location_names = this.elements.button.querySelectorAll('span.location_name');
    location_names.forEach(el => el.classList.add('hidden'));

    let pickedCity = event.target.innerText.toString();
    if (event.target.innerText.toString() == window.locations.RIYADH) {
      pickedCity = 'RIYADH';
    } else if (event.target.innerText.toString() == window.locations.JEDDAH) {
      pickedCity = 'JEDDAH'
    } else if (event.target.innerText.toString() == window.locations.DOHA) {
      pickedCity = 'DOHA'
    }

    if (pickedCity == window.locations.RIYADH) {
      this.elements.button.querySelector('span.riyadh').classList.remove('hidden');
    } else if (pickedCity == window.locations.JEDDAH) {
      this.elements.button.querySelector('span.jeddah').classList.remove('hidden');
    } else if (pickedCity == window.locations.DOHA) {
      this.elements.button.querySelector('span.doha').classList.remove('hidden');
    }

    localStorage.setItem('selectedCity', pickedCity);
    sessionStorage.setItem('locationPicked', true); // for controlling location modal based on session
    this.changeCity();
    this.changeForm();
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function () {
        location.replace(Shopify.routes.root);
      },
      error: function (XMLHttpRequest, textStatus) {
      }
    });
  }
  changePDPbtn() {
    const template = document?.querySelector('.template-main-product-kids') || document.querySelector('.main_new-main-product') || document.querySelector('.template-product-bundle-gift') || document.querySelector('.template-cake-balloon');
    const productFormBtn = document.querySelector('product-form form [name="add"]');
    const stickyATCbtn = document.querySelector('sticky-atc .buy');
    const productFormBtnSecondary = document.querySelector('.customize-wrapper [name="add"]');
    var selectedCity = localStorage.getItem('selectedCity') ?? 'riyadh';
    var Riyadh_PDP = document.querySelector('.Riyadh_exclusive-PDP');
  }

  changeForm() {
    var Riyadh_PDP = document.querySelector('.Riyadh_exclusive-PDP');
    const template = document?.querySelector('.template-main-product-kids') || document.querySelector('.main_new-main-product') || document.querySelector('.template-product-bundle-gift') || document.querySelector('.template-cake-balloon');

    if (template) {

      const customizeWrapper = template.querySelector('.customize-wrapper');
      const switchWrapper = customizeWrapper.querySelector('.switch-wrapper');
      const formWrapper = customizeWrapper.querySelector('.form-wrapper');
      const duplicateBtn = customizeWrapper.querySelector('.buttons-wrapper');
      const customizeToggle = template.querySelector('.switch-wrapper input[type="checkbox"]');
      const additionalProps = template.querySelectorAll('.additional-props .prop-wrapper-msg');
      const customizeBtn = customizeWrapper.querySelector('a[data-toggle="customize-drop"]');
      const changeEvent = new Event('change');
      if (selectedCity.trim() == "OTHER CITY") {
        switchWrapper.classList.add('hidden');
        formWrapper.classList.add('hidden');
        if (document.querySelector('.main_new-main-product')) {
          duplicateBtn?.classList.add('hidden');
          customizeBtn?.setAttribute('disabled', true);
        }
      } else {
        switchWrapper.classList.remove('hidden');
        if (document.querySelector('.main_new-main-product')) {
          duplicateBtn?.classList.remove('hidden')
          customizeBtn?.setAttribute('disabled', false);
        }
        additionalProps.forEach(element => {
          element.classList.remove('hidden');
        })
      }
    }
  }

  changeCity() {
    var selectedCity = localStorage.getItem("selectedCity")?.toLowerCase() ?? 'riyadh';
    var className = '.otherCity';
    var NotclassName = '.Riyadh';
    var Riyadh_cart_item = document.querySelector('.Riyadh_exclusive_cart-item');
    var Riyadh_PDP = document.querySelector('.Riyadh_exclusive-PDP');

    if (['riyadh', 'الرياض'].includes(selectedCity.toLowerCase().trim())) {
      if (Riyadh_cart_item) {
        Riyadh_cart_item?.classList?.add('hidden');
        document.querySelector('.cart__select-shipment').removeAttribute('disabled');
      }
      if (Riyadh_PDP) {
        Riyadh_PDP?.classList?.add('hidden');
      }

    } else if (['jeddah', 'جدة'].includes(selectedCity.toLowerCase().trim())) {
      if (Riyadh_cart_item) {
        Riyadh_cart_item?.classList?.add('hidden');
        document.querySelector('.cart__select-shipment').removeAttribute('disabled');
      }
      if (Riyadh_PDP) {
        Riyadh_PDP?.classList?.add('hidden');
      }

    } else if (['doha', 'الدوحة'].includes(selectedCity.toLowerCase().trim())) {
      if (Riyadh_cart_item) {
        Riyadh_cart_item?.classList?.add('hidden');
        document.querySelector('.cart__select-shipment').removeAttribute('disabled');
      }
      if (Riyadh_PDP) {
        Riyadh_PDP?.classList?.add('hidden');
      }
    }
    else {
      className = '.Riyadh';
      NotclassName = '.otherCity';
      if (Riyadh_cart_item) {
        Riyadh_cart_item?.classList?.remove('hidden');
        document.querySelector('.cart__select-shipment').setAttribute('disabled', true);
      }
      if (Riyadh_PDP) {
        Riyadh_PDP?.classList?.remove('hidden');
      }

    }

    var Classelements = document.querySelectorAll(className);
    var NotclassNameelements = document.querySelectorAll(NotclassName);
    for (let index = 0; index < Classelements.length; index++) {
      const element = Classelements[index];
      element.classList.add('hidden');
    }
    for (let index = 0; index < NotclassNameelements.length; index++) {
      const element = NotclassNameelements[index];
      element.classList.remove('hidden');
    }

    if (Riyadh_PDP) {
      this.changePDPbtn();
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

class CustomizationProduct extends HTMLElement {
  setFormInput(option) {
    let value = option.dataset.value;
    let name = option.dataset.name;
    this.closest('.product__info-wrapper').querySelector('variant-radios').triggerOptionChange(name, value);
  }

  updateInputs(optionsToggle) {
    let optionsWrapper = optionsToggle ? optionsToggle.closest('.switch-wrapper')?.nextElementSibling : null;
    let value = optionsToggle?.checked || false;
    if (value == true) {
      optionsWrapper.classList.remove('hidden');
      let selectedOptions = optionsWrapper.querySelectorAll('[data-default]');
      const template = document?.querySelector('.template-main-product-kids') || document.querySelector('.main_new-main-product') || document.querySelector('.template-product-bundle-gift') || document.querySelector('.template-cake-balloon');
      selectedOptions.forEach(option => {
        option.classList.add('checked');
        option.querySelector('.option_price')?.classList.add('hidden');
        this.setFormInput(option);
      })

      if (template) {
        if (selectedCity.trim() == "RIYADH" || selectedCity.trim() == "JEDDAH") {
          setTimeout(() => {
            var customizeWrapper = document.querySelector('.customize-wrapper'),
              option2 = '', option1 = '';
            const optionsWrapper1 = customizeWrapper.querySelectorAll('.options-wrapper')[0] || '';
            const optionsWrapper2 = customizeWrapper.querySelectorAll('.options-wrapper')[1] || '';

            if (optionsWrapper1 != '' && optionsWrapper2 != '') {
              option1 = optionsWrapper1.querySelectorAll('.product-option-selector')[1] || '';
              option2 = optionsWrapper2?.querySelectorAll('.product-option-selector')[2] || '';
            } else if (optionsWrapper1 != '' && optionsWrapper2 == '') {
              option2 = optionsWrapper1.querySelectorAll('.product-option-selector')[0] || '';
            }
            const clickEvt = new Event('click');
            if (option1) {
              option1.dispatchEvent(clickEvt);
              option1.classList.add('checked');
              option1.querySelector('.option_price')?.classList.add('hidden');
              this.setFormInput(option1);
            }
            if (option2) {
              option2.dispatchEvent(clickEvt);
              option2.classList.add('checked');
              option2.querySelector('.option_price')?.classList.add('hidden');
              this.setFormInput(option2);
            }
          }, 500);
        }
      } else {
        selectedOptions.forEach(option => {
          option.classList.add('checked');
          this.setFormInput(option);
        })
      }

    } else {
      if (optionsWrapper) {
        optionsWrapper.classList.add('hidden');
        let options = optionsWrapper.querySelectorAll('.product-option-selector');
        options.forEach(option => {
          if (option.dataset.value == 'None') {
            option.classList.add('checked');
            this.setFormInput(option);
          } else {
            option.classList.remove('checked');
          }
        })

      }

    }
  }

  constructor() {
    super();
    this.init();
  }

  init() {
    var qtyButtons = document.querySelectorAll('.btn-number');
    var customizeToggles = document.querySelectorAll('[data-toggle="customize-drop"]');
    var optionsToggle = document.querySelector('.switch input[type="checkbox"]');
    let optionsWrapper = optionsToggle ? optionsToggle.closest('.switch-wrapper')?.nextElementSibling : null;
    qtyButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        let fieldName = button.getAttribute('data-field');
        let type = button.getAttribute('data-type');
        var input = document.querySelectorAll("input[name='" + fieldName + "']");
        var currentVal = parseInt(input[0].value);
        const variant_id = input[0].dataset.variant;
        const handle = input[0].dataset.handle;
        let accessories_input = document.querySelector(`input[name="properties[Accessories][${handle}]"]`);
        if (!isNaN(currentVal)) {
          if (type == 'minus') {
            let plusBtn = button.closest('.input-group').querySelector('button[data-type="plus"]');
            if (currentVal > input[0].getAttribute('min')) {

              input[0].value = currentVal - 1;

              input[1].value = variant_id + ":" + (currentVal - 1);
              accessories_input.value = (currentVal - 1)
              plusBtn.removeAttribute('disabled')
            }
            if (parseInt(input[0].value) == input[0].getAttribute('min')) {
              button.setAttribute('disabled', true);
              plusBtn.removeAttribute('disabled')
            }
          } else if (type == 'plus') {
            let minusBtn = button.closest('.input-group').querySelector('button[data-type="minus"]');

            if (currentVal < input[0].getAttribute('max')) {
              input[0].value = (currentVal + 1);
              input[1].value = variant_id + ":" + (currentVal + 1);

              accessories_input.value = (currentVal + 1)
            }

            if (currentVal > input[0].getAttribute('min') || currentVal < input[0].getAttribute('max')) {
              minusBtn.removeAttribute('disabled');
            }

            if (parseInt(input.value) == input[0].getAttribute('max')) {
              button.setAttribute('disabled', true);
              minusBtn.removeAttribute('disabled');
            }
          }
        } else {
          input[1].value = 1
          input[0].value = variant_id + ":" + 1;
          accessories_input.value = 0
        }
      });
    })
    document.querySelectorAll('.input-number').forEach(button => {

      button.addEventListener('focusin', function () {
        button.dataset.oldValue = button.value;
      });
      button.addEventListener('keyup', function () {
        let minValue = parseInt(button.getAttribute('min'));
        let maxValue = parseInt(button.getAttribute('max'));
        let valueCurrent = parseInt(button.value);

        const name = button.getAttribute('name');

        if (valueCurrent >= minValue) {
          document.querySelector(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttribute('disabled')
        } else {
          button.value = button.dataset.oldValue;
        }
        if (valueCurrent <= maxValue) {
          document.querySelector(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttribute('disabled')
        } else {
          button.value = button.dataset.oldValue;
        }
      });
      button.addEventListener('change', () => {
        let minValue = parseInt(button.getAttribute('min'));
        let maxValue = parseInt(button.getAttribute('max'));
        let valueCurrent = parseInt(button.value);

        const name = button.getAttribute('name');

        if (valueCurrent >= minValue) {
          if (valueCurrent > 1) {
            document.querySelector(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttribute('disabled')
          }
        } else {
          button.value = button.dataset.oldValue;
        }
        if (valueCurrent <= maxValue) {
          document.querySelector(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttribute('disabled')
        } else {
          button.value = button.dataset.oldValue;
        }
      })
    });
    customizeToggles.forEach(customizeToggle => {
      customizeToggle.addEventListener('click', function () {
        var toggleVal = customizeToggle.dataset.toggle;
        var toggleOpen = customizeToggle.dataset.open;
        var customizeLabel = customizeToggle.dataset.customizeLabel;
        var closeLabel = customizeToggle.dataset.closeLabel;
        var customizeWrapper = document.querySelector(`#${toggleVal}`);
        if (toggleOpen == 'false') {
          customizeToggles.forEach(element => {
            element.setAttribute('data-open', 'true');
            element.innerHTML = closeLabel;
          })
        } else {
          customizeToggles.forEach(element => {
            element.setAttribute('data-open', 'false');
            element.innerHTML = customizeLabel;
          })

        }
        customizeWrapper.classList.toggle('drawer-hidden');
      });
    });
    if (optionsToggle) {
      setTimeout(() => {
        optionsToggle.addEventListener('change', function (e) {
          document.querySelector('customization-product').updateInputs(optionsToggle);
        });
      }, 100);
    }


    let options = optionsWrapper?.querySelectorAll('.product-option-selector') || null;
    if (options) {
      options.forEach(option => {
        let siblings = getSiblings(option);

        option.addEventListener('click', function () {

          option.querySelector('.option_price')?.classList.add('hidden');

          siblings.forEach(element => {
            element.classList.remove('checked');
          });

          option.classList.toggle('checked');
          document.querySelector('customization-product').setFormInput(option);
        })
      });
    }
    
    document.querySelectorAll('.line-item-property__field input, .line-item-property__field textarea').forEach(input => {
      input.addEventListener('keyup', function () {
        let name = input.name;
        let value = input.value;
        let chars = input.closest('.line-item-property__field').querySelector('.char-size');
        let productprop = document.querySelector(`.product-form .form [name="${name.trim()}"]`);
        productprop.value = value;
        if (chars) {
          chars.innerHTML = parseInt(input.getAttribute("maxlength")) - value.length;
        }
        const radios = this.closest('.product__info-wrapper').querySelector('variant-radios');
      })
    })
    const propSelect = document.querySelector('.genderSelector select');
    if (propSelect) {
      propSelect.addEventListener('change', function () {
        let name = propSelect.name;
        let value = propSelect.value;
        let productprop = document.querySelector(`.product-form .form input[name="${name}"]`);
        productprop.value = value;
      })
    }
  }
}

customElements.define('customization-product', CustomizationProduct)

const secondaryATC = document.querySelector('.customize-wrapper [name="add"]');
if (secondaryATC) {

  secondaryATC.addEventListener('click', function () {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const pdpATC = productForm.querySelector('[name="add"]');
    $(pdpATC).trigger('click');
  })
}

var acc = document.getElementsByClassName("menu-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
const form = document.querySelector('form#ContactFooter');
// const usernameEl = document.querySelector('#username');
const emailEl = document.querySelector('input[name="contact[email]"]')
// const passwordEl = document.querySelector('#password');
// const confirmPasswordEl = document.querySelector('#confirm-password');



const checkUsername = () => {

  let valid = false;

  const min = 3,
    max = 25;

  const username = usernameEl?.value.trim();

  if (!isRequired(username)) {
    showError(usernameEl, 'Username cannot be blank.');
  } else if (!isBetween(username.length, min, max)) {
    showError(usernameEl, `Username must be between ${min} and ${max} characters.`)
  } else {
    showSuccess(usernameEl);
    valid = true;
  }
  return valid;
};


const checkEmail = () => {
  let valid = false;
  const email = emailEl.value.trim();
  if (!isRequired(email)) {
    showError(emailEl, 'Email cannot be blank.');
  } else if (!isEmailValid(email)) {
    showError(emailEl, 'Email is not valid.')
  } else {
    showSuccess(emailEl);
    valid = true;
  }
  return valid;
};

const checkPassword = () => {
  let valid = false;


  const password = passwordEl.value.trim();

  if (!isRequired(password)) {
    showError(passwordEl, 'Password cannot be blank.');
  } else if (!isPasswordSecure(password)) {
    showError(passwordEl, 'Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character in (!@#$%^&*)');
  } else {
    showSuccess(passwordEl);
    valid = true;
  }

  return valid;
};

const checkConfirmPassword = () => {
  let valid = false;
  // check confirm password
  const confirmPassword = confirmPasswordEl.value.trim();
  const password = passwordEl.value.trim();

  if (!isRequired(confirmPassword)) {
    showError(confirmPasswordEl, 'Please enter the password again');
  } else if (password !== confirmPassword) {
    showError(confirmPasswordEl, 'The password does not match');
  } else {
    showSuccess(confirmPasswordEl);
    valid = true;
  }

  return valid;
};

const isEmailValid = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const isPasswordSecure = (password) => {
  const re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  return re.test(password);
};

const isRequired = value => value === '' ? false : true;
const isBetween = (length, min, max) => length < min || length > max ? false : true;


const showError = (input, message) => {
  // get the form-field element
  const formField = input.parentElement;
  // add the error class
  formField.classList.remove('success');
  formField.classList.add('error');

  // show the error message
  const error = formField.querySelector('small');
  error.textContent = message;
};

const showSuccess = (input) => {
  // get the form-field element
  const formField = input.parentElement;

  // remove the error class
  formField.classList.remove('error');
  formField.classList.add('success');

  // hide the error message
  const error = formField.querySelector('small');
  error.textContent = '';
}


form.addEventListener('submit', function (e) {
  // prevent the form from submitting
  e.preventDefault();

  // validate fields
  let isUsernameValid = checkUsername(),
    isEmailValid = checkEmail(),
    isPasswordValid = checkPassword(),
    isConfirmPasswordValid = checkConfirmPassword();

  let isFormValid = isUsernameValid &&
    isEmailValid &&
    isPasswordValid &&
    isConfirmPasswordValid;

  // submit to the server if the form is valid
  if (isFormValid) {

  }
});

debounce = (fn, delay = 500) => {
  let timeoutId;
  return (...args) => {
    // cancel the previous timer
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // setup a new timer
    timeoutId = setTimeout(() => {
      fn.apply(null, args)
    }, delay);
  };
};

form.addEventListener('input', debounce(function (e) {
  switch (e.target.name) {
    case 'username':
      checkUsername();
      break;
    case 'email':
      checkEmail();
      break;
    case 'password':
      checkPassword();
      break;
    case 'confirm-password':
      checkConfirmPassword();
      break;
  }
}));
const listItems = document.querySelectorAll('.predictive-search__list-item');
const searchHeader = document.querySelector('.template-search__header');
listItems.forEach(element => {
  if (selectedCity.trim() == "RIYADH") {
    const isOtherCity = element.getAttribute('data-othercity') ? 'true' : '';
    if (isOtherCity == 'true') {
      element.classList.add('d-none');
    }
  }
  if (selectedCity.trim() == "OTHER CITY") {
    const isRiyadh = element.getAttribute('data-Riyadh') ? 'true' : '';
    if (isRiyadh == 'true') {
      element.classList.add('d-none');
    }
  }
});
if (selectedCity.trim() == "RIYADH") {
  searchHeader?.querySelector('.OtherCity')?.classList.add('d-none');
}
if (selectedCity.trim() == "OTHER CITY") {
  searchHeader?.querySelector('.Riyadh').classList.add('d-none');
}